export default [
  {
    path: '/tourStore/applyTrail',
    name: 'tourStore_applyTrail',
    meta: {
      title: '申请试用',
      pageId: 'applyTrail',
      pageName: '申请试用',
      parentId: 'tourStore',
      parentName: '巡店',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/tourStore/applyTrail/applyTrail.vue'], resolve),
  },
  {
    path: '/tourStore/aiAnalysis',
    name: 'tourStore_aiAnalysis',
    meta: {
      title: 'AI分析',
      pageId: 'aiAnalysis',
      pageName: 'AI分析',
      parentId: 'tourStore',
      parentName: '巡店',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/tourStore/aiAnalysis/aiAnalysis.vue'], resolve),
  },
  {
    path: '/tourStore/taskExpireWarning',
    name: 'tourStore_taskExpireWarning',
    meta: {
      title: '重复任务到期预警',
      pageId: 'taskExpireWarning',
      pageName: '重复任务到期预警',
      parentId: 'tourStore',
      parentName: '巡店',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/tourStore/taskExpireWarning/taskExpireWarning.vue'], resolve),
  },
];
